import './styles.css';
import React from 'react';
import { Routes, Route, Navigate, useParams, useLocation } from 'react-router-dom';
import { flowHome, playbooksIndex } from '../_shared/flow-links';
import { LauncherListPage } from './components/LauncherListPage';
import { LauncherSettingsPage } from './components/LauncherSettingsPage';
import { LauncherDetailPage } from './components/LauncherDetailPage';
import { EventManagerPage } from './components/EventManagerPage';
import { TemplateAdminPage } from './components/TemplateAdminPage';

// Feature gate — set to true when Event Manager is ready
const EVENT_MANAGER_ENABLED = true;

// Wrapper that keys on campaign id so React fully remounts (resets all state)
// when navigating between different campaigns
function DetailPageKeyed() {
  const { id } = useParams();
  return <LauncherDetailPage key={id} />;
}

function EventManagerKeyed() {
  const { id } = useParams();
  return <EventManagerPage key={id} />;
}

// `/tools/launcher/v2/<rest>?<q>` → `/tools/playbooks/<rest>?<q>` (same-tab, replace).
function LegacyV2Redirect() {
  const location = useLocation();
  const rest = location.pathname.replace(/^.*?\/v2(?=\/|$)/, '');
  return <Navigate to={`${playbooksIndex()}${rest}${location.search}`} replace />;
}

export default function LauncherApp() {
  // Dark mode is host-owned (MiniAppLayout's useMiniAppDarkMode) — it handles
  // localStorage AND the prefers-color-scheme fallback. The old per-app init
  // here read localStorage only, so with empty storage it stomped a
  // system-preference dark theme back to light on mount.
  return (
    <Routes>
      <Route index element={<LauncherListPage eventManagerEnabled={EVENT_MANAGER_ENABLED} />} />
      <Route path="templates" element={<TemplateAdminPage />} />
      <Route path="contacts" element={<Navigate to={flowHome('plays')} replace />} />
      <Route path="settings" element={<LauncherSettingsPage />} />
      <Route path=":id" element={<DetailPageKeyed />} />
      {EVENT_MANAGER_ENABLED && (
        <Route path=":id/manager" element={<EventManagerKeyed />} />
      )}
      {/* Launcher V2 became its own mini-app, Playbooks (mini-apps/playbooks).
          Keep old /tools/launcher/v2/* deep links working. */}
      <Route path="v2/*" element={<LegacyV2Redirect />} />
    </Routes>
  );
}
